import { createContext, useContext, type ReactNode } from 'react';
import { useAppStore, type PanelId } from '../../state/store';

const PanelEmbedContext = createContext(false);

/** Tab stacks set this so nested `Panel` skips the accordion header. */
export function PanelEmbedProvider({ children }: { children: ReactNode }) {
  return <PanelEmbedContext.Provider value={true}>{children}</PanelEmbedContext.Provider>;
}

interface PanelProps {
  id: PanelId;
  title: string;
  children: ReactNode;
  actions?: ReactNode;
}

export function Panel({ id, title, children, actions }: PanelProps) {
  const embedded = useContext(PanelEmbedContext);
  const open = useAppStore((state) => state.panels[id]);
  const toggle = useAppStore((state) => state.togglePanel);

  if (embedded) {
    return (
      <section className="panel panel--embedded">
        <div className="panel__embed-body">{children}</div>
        {actions && <div className="panel__actions">{actions}</div>}
      </section>
    );
  }

  return (
    <section className="panel">
      <button type="button" className="panel__header" onClick={() => toggle(id)}>
        <span>{title}</span>
        <span>{open ? '▾' : '▸'}</span>
      </button>
      {open && children}
      {open && actions && <div className="panel__actions">{actions}</div>}
    </section>
  );
}
